import React from 'react';
import { Flex, Typography } from 'antd';
import RoundContainer from '../RoundContainer/RoundContainer';
import { CloudFilled } from '@ant-design/icons';
import classes from './Card.module.css';
import { useIntl } from 'react-intl';
import {
  ApplicationOverlay,
  BlockedOverlay,
  ClosedOverlay,
  FrozenOverlay,
  SuspendedOverlay,
  InactiveOverlay
} from './overlays';
import { CStatus } from 'entities/card/model/types';
import clsx from 'clsx';

type CardProps = {
  shortNumber: string;
  bgColor: string;
  size?: 's' | 'm' | 'l';
  selected?: boolean;
  status?: CStatus;
  virtual?: boolean;
  onClick?: () => unknown;
  id?: string;
  title?: string;
};

const Card: React.FC<CardProps> = ({
  shortNumber,
  bgColor,
  size = 'm',
  status,
  selected = false,
  virtual = false,
  onClick,
  id,
  title
}) => {
  const isLarge = size === 'l';
  const isMedium = size === 'm'; 

  const renderOverlay = () => {
    switch (status) {
      case CStatus.SoftBlocked:
        return <FrozenOverlay />;
      case CStatus.Blocked:
        return <BlockedOverlay />;
      case CStatus.Closed:
        return <ClosedOverlay />;
      case CStatus.Suspended:
        return <SuspendedOverlay />;
    }
  };

  return (
    <Flex
      id={id}
      justify="space-between"
      align="flex-end"
      className={clsx(
        isLarge ? classes['card-wrapper-l'] : isMedium ? classes['card-wrapper-m'] : classes['card-wrapper-s'],
        selected ? classes.selected : '',
      )}
      style={{ background: bgColor }}
      onClick={onClick}>
      <Typography.Text className={classes['text']}>
        {`${isLarge ? '•' : ''}${shortNumber}`}
      </Typography.Text>
      <div className={classes['card-placeholder']}>{title || ''}</div>
      {/* <img
        width={isLarge ? 64 : 20}
        height={isLarge ? 40 : 12}
        src={mastercard}
        className={classes.img}
      /> */}
      {isLarge &&
        (virtual ? (
          <div id={classes.virtual}>
            <RoundContainer color={'rgba(0, 0, 0, 0.1)'} padding={8}>
              <CloudFilled style={{ fontSize: 24, color: 'white' }} />
            </RoundContainer>
          </div>
        ) : (
          <img id={classes.chip} width={48} src={'/chip.png'} />
        ))}
      {renderOverlay()}
    </Flex>
  );
};

export default Card;
